"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var buffer_1 = require("buffer");
var StorageServices = /** @class */ (function () {
    function StorageServices() {
    }
    StorageServices.SetCookieUser = function (value) {
        var cookieStore = {};
        try {
            if (sessionStorage.getItem(StorageServices.cookieName)) {
                cookieStore = JSON.parse(buffer_1.Buffer.from(sessionStorage.getItem(StorageServices.cookieName) || "", "base64").toString("ascii"));
                cookieStore.user = value;
                sessionStorage.setItem(StorageServices.cookieName, buffer_1.Buffer.from(JSON.stringify(cookieStore)).toString("base64"));
            }
            else {
                cookieStore.user = value;
                sessionStorage.setItem(StorageServices.cookieName, buffer_1.Buffer.from(JSON.stringify(cookieStore)).toString("base64"));
            }
        }
        catch (error) {
            console.log(error);
        }
    };
    StorageServices.GetCookieUser = function () {
        try {
            if (sessionStorage.getItem(StorageServices.cookieName)) {
                var cookieStore = JSON.parse(buffer_1.Buffer.from(sessionStorage.getItem(StorageServices.cookieName) || "", "base64").toString("ascii"));
                return cookieStore.user;
            }
        }
        catch (error) {
            console.log(error);
        }
    };
    StorageServices.SetCookieUserSizeGuideActive = function (value) {
        var cookieStore = {};
        try {
            if (sessionStorage.getItem(StorageServices.cookieName)) {
                cookieStore = JSON.parse(buffer_1.Buffer.from(sessionStorage.getItem(StorageServices.cookieName) || "", "base64").toString("ascii"));
                cookieStore.user.SizeGuideActive = value;
                sessionStorage.setItem(StorageServices.cookieName, buffer_1.Buffer.from(JSON.stringify(cookieStore)).toString("base64"));
            }
        }
        catch (error) {
            console.log(error);
        }
    };
    StorageServices.SetCookieUserSizeGuideActiveChange = function (value) {
        var cookieStore = {};
        try {
            if (sessionStorage.getItem(StorageServices.cookieName)) {
                cookieStore = JSON.parse(buffer_1.Buffer.from(sessionStorage.getItem(StorageServices.cookieName) || "", "base64").toString("ascii"));
                cookieStore.user.SizeGuideActive += value;
                sessionStorage.setItem(StorageServices.cookieName, buffer_1.Buffer.from(JSON.stringify(cookieStore)).toString("base64"));
            }
        }
        catch (error) {
            console.log(error);
        }
    };
    StorageServices.GetCookieUserCredentials = function () {
        var UserCred = {};
        try {
            if (sessionStorage.getItem(StorageServices.cookieName)) {
                var cookieStore = JSON.parse(buffer_1.Buffer.from(sessionStorage.getItem(StorageServices.cookieName) || "", "base64").toString("ascii"));
                UserCred.UserId = cookieStore.user.UserId;
                UserCred.CompanyId = cookieStore.user.CompanyId;
                UserCred.PlatformId = cookieStore.user.PlatformId;
            }
            else {
                UserCred.UserId = 0;
                UserCred.CompanyId = 0;
                UserCred.PlatformId = 0;
            }
        }
        catch (error) {
            console.log(error);
        }
        return UserCred;
    };
    StorageServices.ExistsCookieUser = function () {
        try {
            if (sessionStorage.getItem(StorageServices.cookieName)) {
                var cookieStore = JSON.parse(buffer_1.Buffer.from(sessionStorage.getItem(StorageServices.cookieName) || "", "base64").toString("ascii"));
                return cookieStore.user !== undefined && cookieStore.user !== null;
            }
            else {
                return false;
            }
        }
        catch (error) {
            console.log(error);
        }
        return false;
    };
    StorageServices.FlushCookie = function () {
        try {
            sessionStorage.removeItem(StorageServices.cookieName);
        }
        catch (error) {
            console.log(error);
        }
    };
    StorageServices.cookieName = "FP-Cookie";
    return StorageServices;
}());
exports.default = StorageServices;
//# sourceMappingURL=StorageServices.js.map